// Home 组件 - 博客主页
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTag, setSelectedTag] = useState('');

  // 模拟获取博客文章数据
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        // 模拟API调用延迟
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // 模拟博客文章数据
        const mockPosts = [
          {
            id: 1,
            title: "我的React学习之旅",
            excerpt: "记录我在学习React过程中的心得体会，包括组件化思想、状态管理等内容。",
            author: "张三",
            date: "2024-01-15",
            tags: ["React", "JavaScript", "前端"],
            readTime: "5分钟阅读"
          },
          {
            id: 2,
            title: "深入理解JavaScript闭包",
            excerpt: "闭包是JavaScript中的一个重要概念，本文将通过实例详解闭包的工作原理和应用场景。",
            author: "李四",
            date: "2024-01-10",
            tags: ["JavaScript", "闭包", "编程"],
            readTime: "8分钟阅读"
          },
          {
            id: 3,
            title: "CSS Grid布局完全指南",
            excerpt: "CSS Grid是现代Web布局的强大工具，本文将带你全面了解Grid的各种属性和用法。",
            author: "王五",
            date: "2024-01-05",
            tags: ["CSS", "布局", "前端"],
            readTime: "10分钟阅读"
          },
          {
            id: 4,
            title: "Node.js实战：构建RESTful API",
            excerpt: "使用Node.js和Express框架构建一个完整的RESTful API服务，并实现基本的CRUD操作。",
            author: "赵六",
            date: "2023-12-28",
            tags: ["Node.js", "API", "后端"],
            readTime: "12分钟阅读"
          },
          {
            id: 5,
            title: "Vue 3 Composition API详解",
            excerpt: "Vue 3引入了Composition API，提供了更灵活的组件逻辑组织方式。本文将详细介绍其使用方法。",
            author: "孙七",
            date: "2023-12-20",
            tags: ["Vue", "前端", "框架"],
            readTime: "7分钟阅读"
          },
          {
            id: 6,
            title: "Webpack 5从入门到精通",
            excerpt: "Webpack是现代前端开发的重要工具，本文将介绍Webpack 5的新特性和配置方法。",
            author: "周八",
            date: "2023-12-15",
            tags: ["Webpack", "构建工具", "前端"],
            readTime: "15分钟阅读"
          },
          {
            id: 7,
            title: "TypeScript进阶技巧",
            excerpt: "掌握TypeScript的一些高级特性和最佳实践，提升代码质量和开发效率。",
            author: "吴九",
            date: "2023-12-10",
            tags: ["TypeScript", "JavaScript", "编程"],
            readTime: "9分钟阅读"
          }
        ];
        
        setPosts(mockPosts);
        setLoading(false);
      } catch (err) {
        console.error("加载文章失败:", err);
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  // 获取所有标签
  const getAllTags = () => {
    const tags = new Set();
    posts.forEach(post => {
      post.tags.forEach(tag => tags.add(tag));
    });
    return Array.from(tags);
  };

  // 过滤文章
  const filteredPosts = posts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesTag = selectedTag === '' || post.tags.includes(selectedTag);
    return matchesSearch && matchesTag;
  });

  // 计算分页
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  // 处理分页点击
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // 处理搜索
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  // 处理标签筛选
  const handleTagSelect = (tag) => {
    setSelectedTag(tag === selectedTag ? '' : tag);
    setCurrentPage(1);
  };

  if (loading) {
    return (
      <div className="home-container">
        <div className="loading">正在加载博客文章...</div>
      </div>
    );
  }

  return (
    <div className="home-container">
      {/* 主要内容区域 */}
      <main className="main-content">
        {/* 搜索和筛选区域 */}
        <section className="search-section">
          <div className="search-box">
            <input
              type="text"
              placeholder="搜索文章..."
              value={searchTerm}
              onChange={handleSearch}
              className="search-input"
            />
            <button className="search-button">🔍</button>
          </div>
          
          <div className="tags-filter">
            <h3>按标签筛选:</h3>
            <div className="tags-list">
              <button 
                className={`tag-item ${selectedTag === '' ? 'active' : ''}`}
                onClick={() => handleTagSelect('')}
              >
                全部
              </button>
              {getAllTags().map((tag, index) => (
                <button
                  key={index}
                  className={`tag-item ${selectedTag === tag ? 'active' : ''}`}
                  onClick={() => handleTagSelect(tag)}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* 文章列表 */}
        <section className="posts-section">
          <h2>最新文章</h2>
          {currentPosts.length > 0 ? (
            <>
              <div className="posts-list">
                {currentPosts.map(post => (
                  <article key={post.id} className="post-card">
                    <div className="post-header">
                      <h3 className="post-title">
                        <Link to={`/post/${post.id}`} className="post-link">
                          {post.title}
                        </Link>
                      </h3>
                      <div className="post-meta">
                        <span className="post-author">作者: {post.author}</span>
                        <span className="post-date">{post.date}</span>
                        <span className="post-read-time">{post.readTime}</span>
                      </div>
                    </div>
                    <p className="post-excerpt">{post.excerpt}</p>
                    <div className="post-footer">
                      <div className="post-tags">
                        {post.tags.map((tag, index) => (
                          <span 
                            key={index} 
                            className={`tag ${selectedTag === tag ? 'active' : ''}`}
                            onClick={() => handleTagSelect(tag)}
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <Link to={`/post/${post.id}`} className="read-more">
                        阅读全文 →
                      </Link>
                    </div>
                  </article>
                ))}
              </div>
              
              {/* 分页控件 */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button 
                    onClick={() => paginate(currentPage - 1)} 
                    disabled={currentPage === 1}
                    className="pagination-button"
                  >
                    上一页
                  </button>
                  
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => paginate(index + 1)}
                      className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  
                  <button 
                    onClick={() => paginate(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                    className="pagination-button"
                  >
                    下一页
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="no-posts">
              <p>没有找到匹配的文章</p>
            </div>
          )}
        </section>
      </main>

      {/* 侧边栏 */}
      <aside className="sidebar">
        {/* 关于我 */}
        <div className="widget about-widget">
          <h3>关于我</h3>
          <div className="about-content">
            <div className="avatar">
              <img src="https://via.placeholder.com/80" alt="作者头像" />
            </div>
            <div className="bio">
              <h4>张三</h4>
              <p>前端开发工程师，热爱技术分享，专注于React和Vue技术栈。</p>
              <div className="social-links">
                <a href="#" className="social-link">GitHub</a>
                <a href="#" className="social-link">Twitter</a>
                <a href="#" className="social-link">LinkedIn</a>
              </div>
            </div>
          </div>
        </div>

        {/* 热门文章 */}
        <div className="widget popular-widget">
          <h3>热门文章</h3>
          <ul className="popular-posts">
            <li>
              <Link to="/post/2" className="popular-post-link">
                <span className="post-number">1</span>
                <span className="post-title">深入理解JavaScript闭包</span>
              </Link>
            </li>
            <li>
              <Link to="/post/1" className="popular-post-link">
                <span className="post-number">2</span>
                <span className="post-title">我的React学习之旅</span>
              </Link>
            </li>
            <li>
              <Link to="/post/3" className="popular-post-link">
                <span className="post-number">3</span>
                <span className="post-title">CSS Grid布局完全指南</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* 标签云 */}
        <div className="widget tags-widget">
          <h3>标签云</h3>
          <div className="tags-cloud">
            {getAllTags().map((tag, index) => (
              <span 
                key={index} 
                className={`tag-cloud-item ${selectedTag === tag ? 'active' : ''}`}
                onClick={() => handleTagSelect(tag)}
                style={{ fontSize: `${12 + Math.random() * 10}px` }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
};

export default Home;
